<mat-toolbar class="content-header">
  <h1 class="page-title">
    <mat-icon fontIcon="location_on"></mat-icon>
    {{'resources.title' | translate}}
  </h1>

  <div class="toolbar-spacer"></div>

  <lib-button (click)="add('unit')" text="{{'units.add_unit' | translate}}" icon="devices_other" color="primary">
  </lib-button>

  <lib-button (click)="add('tracker')" text="{{'units.add_tracker' | translate}}" icon="track_changes" color="primary">
  </lib-button>

  <app-search-bar (searchText)="applyFilter($event)"></app-search-bar>
</mat-toolbar>

<ng-container *ngIf="!loading">
  <div class="resource-container">
    <mat-tab-group class="mat-tab-group resource-list" (selectedTabChange)="onTabChanged($event);"
      [selectedIndex]="tabIndex">
      <!-- Trackers -->
      <mat-tab class="tab">
        <ng-template mat-tab-label>
          <div class="tab-label">
            <mat-icon fontIcon="devices_other"></mat-icon>
            {{'title.resources' | translate}}
          </div>
        </ng-template>

        <div class="filter">
          <mat-form-field appearance="outline" size="small">
            <mat-label>{{'datatable.sort_by'|translate}}</mat-label>
            <mat-select [(value)]="unitSortOrder" (selectionChange)="onUnitSortOrderChange($event.value)">
              <mat-option value="name-asc">{{'datatable.sort_name_asc'|translate}}</mat-option>
              <mat-option value="name-desc">{{'datatable.sort_name_desc'|translate}}</mat-option>
              <mat-option value="type-asc">{{'datatable.sort_type_asc'|translate}}</mat-option>
              <mat-option value="type-desc">{{'datatable.sort_type_desc'|translate}}</mat-option>
              <mat-option value="tracker-asc">{{'datatable.sort_tracker_asc'|translate}}</mat-option>
              <mat-option value="tracker-desc">{{'datatable.sort_tracker_desc'|translate}}</mat-option>
              <mat-option value="created-asc">{{'datatable.sort_created_asc'|translate}}</mat-option>
              <mat-option value="created-desc">{{'datatable.sort_created_desc'|translate}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- units table -->
        <div class="table-container">
          <table mat-table [dataSource]="unitsData" matSort *ngIf="!isMobile else cardUnits">
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <div class="th wifi">
                  <mat-icon fontIcon="wifi"></mat-icon>
                </div>
              </th>

              <td mat-cell *matCellDef="let row" class="color-cell">
                <div class="connect">
                  <div class="status-led {{row.colorName}}"></div>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <div class="th">
                  <mat-icon fontIcon="devices_other"></mat-icon>
                  {{ 'form.name' | translate }}
                </div>
              </th>

              <td mat-cell *matCellDef="let row" (click)="editItem(row, 'unit')" class="selector">
                {{row.name}}
              </td>
            </ng-container>

            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <div class="th">
                  <mat-icon fontIcon="category"></mat-icon>
                  Type
                </div>
              </th>

              <td mat-cell *matCellDef="let row">
                <div *ngIf="!row.setType" class="">{{'units.'+row.type | translate}}</div>
                <div *ngIf="row.setType">
                  {{row.type}}-
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="trackers">
              <th mat-header-cell *matHeaderCellDef>
                <div class="help-div">
                  <div class="th">
                    <mat-icon fontIcon="track_changes"></mat-icon>
                    {{'trackers.title'|translate}}
                  </div>
                </div>
              </th>

              <td mat-cell *matCellDef="let row" [ngClass]="{'unit-not-defined': !row.trackers}">
                <ng-container *ngTemplateOutlet="chipIndicator; context: { $implicit: row.trackers}"></ng-container>
              </td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>
                <div class="th">
                  <mat-icon fontIcon="edit_note"></mat-icon>
                  Actions
                </div>
              </th>

              <td mat-cell *matCellDef="let element;let index=index">
                <div *ngIf="canEditResources()" class="btn-actions">
                  <lib-button color="none" textColor="secondary" (click)="editItem(element, 'unit')" icon="edit"
                    [tooltip]="'resources.edit_unit' | translate">
                  </lib-button>

                  <lib-button color="none" textColor="danger" (click)="delete(element, 'unit')" icon="delete"
                    [tooltip]="'resources.delete_unit' | translate">
                  </lib-button>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="unitsColumns"></tr>

            <tr mat-row *matRowDef="let row; columns: unitsColumns;" [class.current-element]="row.id==currentUnit.id">
            </tr>

            <tr class="mat-row no-data-row" *matNoDataRow>
              <td class="mat-cell" [attr.colspan]="unitsColumns.length">
                <lib-no-data message="form.search_no_data" description="form.search_no_data_desc" icon="search_off">
                </lib-no-data>
              </td>
            </tr>

          </table>

          <mat-paginator #unitPaginator [length]="unitsCount" [pageSize]="50" [pageSizeOptions]="[50, 100, 200]"
            class="paginator"></mat-paginator>
        </div>
      </mat-tab>

      <!-- Tracker tab -->
      <mat-tab class="trackers-mat-tab">
        <ng-template mat-tab-label>
          <div class="tab-label">
            <mat-icon fontIcon="track_changes"></mat-icon>
            {{'trackers.title' | translate}}
          </div>
        </ng-template>

        <div class="filter">
          <mat-form-field appearance="outline" size="small">
            <mat-label>{{'datatable.sort_by'|translate}}</mat-label>
            <mat-select [(value)]="trackerSortOrder" (selectionChange)="onTrackerSortOrderChange($event.value)">
              <mat-option value="name-asc">{{'datatable.sort_name_asc'|translate}}</mat-option>
              <mat-option value="name-desc">{{'datatable.sort_name_desc'|translate}}</mat-option>
              <mat-option value="created-asc">{{'datatable.sort_created_asc'|translate}}</mat-option>
              <mat-option value="created-desc">{{'datatable.sort_created_desc'|translate}}</mat-option>
              <mat-option value="lastMessage-asc">{{'datatable.sort_last_message_asc'|translate}}</mat-option>
              <mat-option value="lastMessage-desc">{{'datatable.sort_last_message_desc'|translate}}</mat-option>
            </mat-select>
          </mat-form-field>

          <lib-button [color]="multiSelectMode ? 'primary' : 'secondary'" icon="checklist"
            [tooltip]="(multiSelectMode ? 'trackers.cancel_multi_select' : 'trackers.multi_select') | translate"
            (click)="toggleMultiSelectMode()"></lib-button>
        </div>

        <div class="bulk-actions" *ngIf="multiSelectMode && selectedTrackersForBulk.length">
          <span class="bulk-selection-count">{{ selectedTrackersForBulk.length }} {{'trackers.selected'|translate}}</span>
          <lib-button color="secondary" icon="bookmark" text="{{'trackers.apply_template_selection'|translate}}"
            (click)="bulkApplyTemplateDirectly()"></lib-button>
          <lib-button color="secondary" icon="settings" text="{{'trackers.configure_selection'|translate}}"
            (click)="bulkEditTrackersDirectly()"></lib-button>
          <lib-button color="secondary" icon="visibility" text="{{'trackers.view_settings_selection'|translate}}"
            (click)="bulkViewTrackerSettings()"></lib-button>
          <lib-button color="none" textColor="danger" icon="delete" text="{{'trackers.delete_selection'|translate}}"
            (click)="bulkDeleteTrackers()"></lib-button>
        </div>

        <div class="table-container">
          <table mat-table [dataSource]="trackersData" #trackerSort="matSort" matSort
            *ngIf="!isMobile else cardTrackers">

            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox *ngIf="multiSelectMode" [checked]="allVisibleTrackersSelected"
                  (change)="toggleSelectAllTrackers()"></mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let row">
                <mat-checkbox *ngIf="multiSelectMode" [(ngModel)]="row.selected"></mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <div class="th wifi">
                  <mat-icon fontIcon="wifi"></mat-icon>
                </div>
              </th>

              <td mat-cell *matCellDef="let row" class="color-cell">
                <div class="status-led {{row.colorName}}"></div>
              </td>
            </ng-container>

            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <div class="th">
                  <mat-icon fontIcon="track_changes"></mat-icon>
                  {{'datatable.name'|translate}}
                </div>
              </th>

              <td mat-cell *matCellDef="let row" (click)="editItem(row, 'tracker')" class="selector">
                {{row.name}}
              </td>
            </ng-container>

            <ng-container matColumnDef="resource">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <div class="th">
                  <mat-icon fontIcon="devices_other"></mat-icon>
                  {{'menu.resource._title'|translate}}
                </div>
              </th>

              <td mat-cell *matCellDef="let row" [class.tracker-not-defined]="!row._unit">
                <mat-chip-set *ngIf="row._unit">
                  <mat-chip color="primary" selected> {{row._unit.name}} </mat-chip>
                </mat-chip-set>
              </td>
            </ng-container>

            <ng-container matColumnDef="serial">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <div class="th">
                  <mat-icon fontIcon="info"></mat-icon>
                  {{'trackers.version' | translate}}
                </div>
              </th>

              <td mat-cell *matCellDef="let row" [ngClass]="{'no-version': !row.version}">
                {{row.version}}
              </td>
            </ng-container>

            <ng-container matColumnDef="lastUpdate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <div class="th">
                  <mat-icon fontIcon="history"></mat-icon>
                  {{'trackers.last_update'|translate}}
                </div>
              </th>
              <td mat-cell *matCellDef="let row"> {{row.lastUpdate | timeFormat : 'dd/MM/yyyy HH:mm:ss'}} </td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>
                <div class="th">
                  <mat-icon fontIcon="edit_note"></mat-icon>
                  Actions
                </div>
              </th>

              <td mat-cell *matCellDef="let element;let index=index">
                <div *ngIf="canEditResources()">
                  <lib-button color="none" textColor="secondary" (click)="editItem(element, 'tracker')" icon="edit"
                    [tooltip]="'resources.edit_tracker' | translate">
                  </lib-button>

                  <lib-button color="none" textColor="danger" (click)="delete(element, 'tracker')" icon="delete"
                    [tooltip]="'resources.delete_tracker' | translate">
                  </lib-button>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="trackersColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: trackersColumns;"
              [class.current-element]="row.id==currentTracker.id"></tr>

            <tr class="mat-row no-data-row" *matNoDataRow>
              <td class="mat-cell" [attr.colspan]="trackersColumns.length">
                <lib-no-data message="form.search_no_data" description="form.search_no_data_desc" icon="search_off">
                </lib-no-data>
              </td>
            </tr>
          </table>

          <mat-paginator #trackerPaginator [length]="trackersCount" [pageSize]="50" [pageSizeOptions]="[50, 100, 200]"
            class="paginator"></mat-paginator>
        </div>
      </mat-tab>
    </mat-tab-group>

    <!-- SETTINGS -->
    <div *ngIf="canEditResources() && sidepanelMounted" [@.disabled]="sidepanelAnimationDisabled"
      [@slideInOut]="sidepanelState" class="sidepanel">
      <mat-toolbar class="sidepanel-header">
        <h1 class="page-title">
          <mat-icon fontIcon="settings"></mat-icon>
          {{'title.settings' | translate}}
        </h1>

        <button mat-icon-button (click)="toggleSidepanel()">
          <mat-icon fontIcon="close"></mat-icon>
        </button>
      </mat-toolbar>

      <div>
        <!-- SidePanel units -->
        <form class="form" *ngIf="sidepanelType == 'unit'">

          <mat-accordion>
            <mat-expansion-panel class="expansion-panel" [expanded]="true">
              <mat-expansion-panel-header class="header-panel">
                <mat-panel-title>
                  <h3>
                    <mat-icon fontIcon="info"></mat-icon>
                    {{'resources.info_unit' | translate}}
                  </h3>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="form-row">
                <mat-form-field appearance="outline" class="header-input">
                  <mat-label>{{'form.name' | translate}}</mat-label>

                  <input matInput placeholder="{{'form.name' | translate}}" [(ngModel)]="currentUnit.name" name="name"
                    (change)="updateUnit($event)">

                  <mat-hint class="error-unique" *ngIf="errorName">{{'units.error_unique' | translate}} </mat-hint>
                </mat-form-field>
              </div>

              <div class="form-row">
                <mat-form-field appearance="outline">
                  <mat-label>{{'units.tracker' | translate}} </mat-label>

                  <mat-select [(ngModel)]="currentUnit.trackerIds" name="trackerIds" multiple
                    (selectionChange)="updateUnit($event)">
                    <mat-option [value]="tracker.id" *ngFor="let tracker of availableTrackers">
                      {{tracker.name}}
                    </mat-option>

                    <ng-container *ngFor="let tracker of usedTrackers">
                      <mat-option [value]="tracker.id" *ngIf="currentUnit.trackerIds.indexOf(tracker.id) >= 0">
                        {{tracker.name}}
                      </mat-option>

                      <mat-option [value]="tracker.id" disabled
                        *ngIf="currentUnit.trackerIds.indexOf(tracker.id) == -1">{{tracker.name}}
                      </mat-option>
                    </ng-container>
                  </mat-select>

                  <mat-error *ngIf="currentUnit.trackerError">
                    {{'form.error' | translate}}
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>{{ 'units.type' | translate }}</mat-label>

                  <mat-select matInput name="type" [(ngModel)]="currentUnit.type" (selectionChange)="updateUnit($event)"
                    [disabled]="currentUnit.type == 'virtual'">
                    <ng-container *ngIf="currentUnit.type === 'virtual'; else otherOptions">
                      <mat-option value="virtual">{{ 'units.virtual' | translate }}</mat-option>
                    </ng-container>

                    <ng-template #otherOptions>
                      <mat-option [value]="unit.value" *ngFor="let unit of unitTypeArray">{{ unit.name }}</mat-option>
                    </ng-template>
                  </mat-select>
                </mat-form-field>
              </div>
            </mat-expansion-panel>
          </mat-accordion>

          <mat-accordion>
            <mat-expansion-panel class="expansion-panel" [expanded]="true">
              <mat-expansion-panel-header class="header-panel">
                <mat-panel-title>
                  <div class="coords-header">
                    <h3>
                      <mat-icon fontIcon="location_on"></mat-icon>
                      {{'units.coordinates' | translate}}
                    </h3>

                    <lib-button *ngIf="!currentUnit.trackers?.length" color="primary"
                      (click)="openTrackerPositionModal()" class="init-pos-btn"
                      tooltip="{{ 'units.tracker_pos.init' | translate }}" icon="gps_fixed">
                      {{ 'units.tracker_pos.init' | translate }}
                    </lib-button>
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="form-row">
                <mat-form-field appearance="outline">
                  <mat-label>X</mat-label>

                  <input matInput type="number" placeholder="0" [(ngModel)]="currentUnit.lastPosition.x"
                    name="lastPosition.x" (change)="updateUnit($event)">
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Y</mat-label>

                  <input matInput type="number" placeholder="0" [(ngModel)]="currentUnit.lastPosition.y"
                    name="lastPosition.y" (change)="updateUnit($event)">
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Z</mat-label>

                  <input matInput type="number" placeholder="0" [(ngModel)]="currentUnit.lastPosition.z"
                    name="lastPosition.z" (change)="updateUnit($event)">
                </mat-form-field>
              </div>

              <div class="form-row">
                <mat-form-field appearance="outline">
                  <mat-label>
                    {{'geometry.longitude' | translate}}
                  </mat-label>

                  <input matInput type="number" placeholder="0" name="lastPosition.lon"
                    [(ngModel)]="currentUnit.lastPosition.lon" (change)="updateUnit($event)">
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>
                    {{'geometry.latitude' | translate}}
                  </mat-label>

                  <input matInput type="number" placeholder="0" name="lastPosition.lat"
                    [(ngModel)]="currentUnit.lastPosition.lat" (change)="updateUnit($event)">
                </mat-form-field>
              </div>
            </mat-expansion-panel>
          </mat-accordion>

          <mat-accordion>
            <mat-expansion-panel class="expansion-panel" [expanded]="true">
              <mat-expansion-panel-header class="header-panel">
                <mat-panel-title>
                  <h3>
                    <mat-icon fontIcon="category"></mat-icon>
                    {{'units.geometry' | translate}}
                  </h3>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="flex-expand">
                <mat-form-field appearance="outline">
                  <mat-label>
                    {{'units.geometry' | translate}}
                  </mat-label>

                  <mat-select matInput [(ngModel)]="currentUnit.collider.geometry" name="collider.geometry"
                    (selectionChange)="updateGeometry($event)">
                    <mat-option value="Point">{{'geometry.point' | translate}}</mat-option>
                    <mat-option value="Sphere">{{'geometry.sphere' | translate}}</mat-option>
                    <mat-option value="Box">{{'geometry.box' | translate}}</mat-option>
                    <mat-option value="Cylinder">{{'geometry.cylinder' | translate}}</mat-option>
                    <mat-option value="Crane hook">{{'geometry.crane_hook' | translate}}</mat-option>
                    <mat-option value="Crane">{{'units.crane' | translate}}</mat-option>
                  </mat-select>
                </mat-form-field>

                <ng-container
                  *ngIf="currentUnit.collider.geometry != 'none' && currentUnit.collider.geometry != 'Crane'">
                  <div class="form-row">
                    <mat-form-field appearance="outline" *ngIf="currentUnit.collider.geometry == 'Box'">
                      <mat-label>
                        {{'geometry.width' | translate}}
                      </mat-label>

                      <input matInput type="number" placeholder="0" name="collider.width"
                        [(ngModel)]="currentUnit.collider.width" (change)="updateUnit($event)">
                    </mat-form-field>

                    <mat-form-field appearance="outline" *ngIf="currentUnit.collider.geometry == 'Box'">
                      <mat-label>
                        {{'geometry.length' | translate}}
                      </mat-label>

                      <input matInput type="number" placeholder="0" name="collider.length"
                        [(ngModel)]="currentUnit.collider.length" (change)="updateUnit($event)">
                    </mat-form-field>

                    <mat-form-field appearance="outline"
                      *ngIf="currentUnit.collider.geometry == 'Box' || currentUnit.collider.geometry == 'Cylinder'">
                      <mat-label>
                        {{'geometry.height' | translate}}
                      </mat-label>

                      <input matInput type="number" placeholder="0" name="collider.height"
                        [(ngModel)]="currentUnit.collider.height" (change)="updateUnit($event)">
                    </mat-form-field>
                  </div>

                  <div class="form-row">
                    <mat-form-field appearance="outline" *ngIf="currentUnit.collider.geometry == 'Sphere'">
                      <mat-label>
                        {{'geometry.radius' | translate}}
                      </mat-label>

                      <input matInput type="number" placeholder="0" name="collider.radius"
                        [(ngModel)]="currentUnit.collider.radius" (change)="updateUnit($event)">
                    </mat-form-field>

                    <mat-form-field appearance="outline" *ngIf="currentUnit.collider.geometry == 'Crane hook'">
                      <mat-label>{{'geometry.hook_margin' | translate}}</mat-label>
                      <input matInput type="number" placeholder="0" name="collider.hookMargin"
                        [(ngModel)]="currentUnit.collider.hookMargin" (change)="updateUnit($event)">
                    </mat-form-field>

                    <mat-form-field appearance="outline"
                      *ngIf="currentUnit.collider.geometry == 'Cylinder' || currentUnit.collider.geometry == 'Crane hook'"
                      (change)="updateUnit($event)">
                      <mat-label>
                        {{'geometry.bottom_radius' | translate}}
                      </mat-label>

                      <input matInput type="number" placeholder="0" [(ngModel)]="currentUnit.collider.bottomradius"
                        name="collider.bottomRadius" (change)="updateUnit($event)">
                    </mat-form-field>

                    <mat-form-field appearance="outline"
                      *ngIf="currentUnit.collider.geometry == 'Cylinder' || currentUnit.collider.geometry == 'Crane hook'">
                      <mat-label>{{'geometry.top_radius' | translate}}</mat-label>
                      <input matInput type="number" placeholder="0" name="collider.topRadius"
                        [(ngModel)]="currentUnit.collider.topradius" (change)="updateUnit($event)">
                    </mat-form-field>
                  </div>

                  <div class="form-row" *ngIf="currentUnit.collider.geometry != 'Crane hook'">
                    <mat-form-field appearance="outline">
                      <mat-label>{{'geometry.offset' | translate}} X</mat-label>
                      <input matInput type="number" placeholder="0" name="collider.offset.x"
                        [(ngModel)]="currentUnit.collider.offset.x" (change)="updateUnit($event)">
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>{{'geometry.offset' | translate}} Y</mat-label>
                      <input matInput type="number" placeholder="0" name="collider.offset.y"
                        [(ngModel)]="currentUnit.collider.offset.y" (change)="updateUnit($event)">
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>{{'geometry.offset' | translate}} Z</mat-label>
                      <input matInput type="number" placeholder="0" name="collider.offset.z"
                        [(ngModel)]="currentUnit.collider.offset.z" (change)="updateUnit($event)">
                    </mat-form-field>
                  </div>
                  <div class="form-row">

                    <mat-form-field appearance="outline" *ngIf="currentUnit.collider.geometry == 'Box'">
                      <mat-label>{{'geometry.extrapolationCoef' | translate}}</mat-label>
                      <input matInput type="number" placeholder="5" name="collider.extrapolationCoef" min="1" max="20"
                        [(ngModel)]="currentUnit.collider.extrapolationCoef" (change)="updateUnit($event)">
                    </mat-form-field>
                  </div>
                </ng-container>

                <ng-container *ngIf="currentUnit.collider && currentUnit.collider.geometry == 'Crane'">
                  <mat-form-field appearance="outline">
                    <mat-label>{{'units.crane_type' | translate}}</mat-label>
                    <mat-select matInput [(ngModel)]="currentUnit.crane.type" name="crane.type"
                      (selectionChange)="updateUnit($event)">
                      <mat-option value="tower">{{'units.tower_crane' | translate}}</mat-option>
                      <mat-option value="mobile">{{'units.mobile_crane' | translate}}</mat-option>
                      <mat-option value="luffing">{{'units.luffing_crane' | translate}}</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <div class="form-row mobile">
                    <mat-form-field appearance="outline">
                      <mat-label>{{'units.crane_height' | translate}}</mat-label>
                      <input matInput type="number" placeholder="0" [(ngModel)]="currentUnit.crane.height"
                        name="crane.height" (change)="updateUnit($event)">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>{{'units.crane_width' | translate}}</mat-label>
                      <input matInput type="number" placeholder="0" name="crane.width"
                        [(ngModel)]="currentUnit.crane.width" (change)="updateUnit($event)">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>{{'units.offset_angle' | translate}}</mat-label>
                      <input matInput type="number" placeholder="0" name="crane.offsetAngle"
                        [(ngModel)]="currentUnit.crane.offsetAngle" (change)="updateUnit($event)">
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>{{'units.unloaded_weight' | translate}}</mat-label>
                      <input matInput type="number" placeholder="150" name="crane.unloadedWeight"
                        [(ngModel)]="currentUnit.crane.unloadedWeight" (change)="updateUnit($event)">
                    </mat-form-field>
                  </div>

                  <div class="form-row mobile">
                    <mat-form-field appearance="outline">
                      <mat-label>{{'units.jib_length' | translate}}</mat-label>
                      <input matInput type="number" placeholder="0" [(ngModel)]="currentUnit.crane.jibLength"
                        name="crane.jibLength" (change)="updateUnit($event)">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>{{'units.jib_height' | translate}}</mat-label>
                      <input matInput type="number" placeholder="0" [(ngModel)]="currentUnit.crane.jibHeight"
                        name="crane.jibHeight" (change)="updateUnit($event)">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>{{'units.counter_jib_length' | translate}}</mat-label>
                      <input matInput type="number" placeholder="0" name="crane.counterJibLength"
                        [(ngModel)]="currentUnit.crane.counterJibLength" (change)="updateUnit($event)">
                    </mat-form-field>
                  </div>

                  <div class="form-row">
                    <mat-form-field appearance="outline" *ngIf="!currentUnit.crane.hookTracker">
                      <mat-label>{{'units.jib_tracker' | translate}}</mat-label>
                      <mat-select [(ngModel)]="currentUnit.crane.jibTracker" name="crane.jibTracker"
                        (selectionChange)="updateUnit($event)">
                        <mat-option [value]="null">{{"form.none"|translate}}</mat-option>
                        <mat-option value="{{tracker.id}}"
                          *ngFor="let tracker of trackers">{{tracker.name}}</mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" *ngIf="!currentUnit.crane.jibTracker">
                      <mat-label>{{'units.hook_tracker' | translate}}</mat-label>
                      <mat-select [(ngModel)]="currentUnit.crane.hookTracker" name="crane.hookTracker"
                        (selectionChange)="updateUnit($event)">
                        <mat-option [value]="null">{{"form.none"|translate}}</mat-option>
                        <mat-option value="{{tracker.id}}"
                          *ngFor="let tracker of trackers">{{tracker.name}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <mat-checkbox [(ngModel)]="currentUnit.crane.fullHeight" name="crane.fullHeight"
                    (change)="updateUnit($event)">
                    {{'units.full_height' | translate}}</mat-checkbox>
                  <mat-checkbox [(ngModel)]="currentUnit.crane.trackerOnTop" name="crane.trackerOnTop"
                    (change)="updateUnit($event, 'crane.trackerOnTop')">
                    {{'units.tracker_on_top' | translate}}
                  </mat-checkbox>
                </ng-container>

              </div>
            </mat-expansion-panel>
          </mat-accordion>


          <mat-accordion>
            <mat-expansion-panel class="expansion-panel">
              <mat-expansion-panel-header class="header-panel">
                <mat-panel-title>
                  <h3>
                    <mat-icon fontIcon="palette"></mat-icon>
                    {{'units.icon' | translate}}
                  </h3>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="form-row">
                <mat-form-field appearance="outline">
                  <mat-label>
                    {{'form.color' | translate}}
                  </mat-label>

                  <mat-select name="color" [(ngModel)]="currentUnit.color" (selectionChange)="updateUnit($event)">
                    <mat-option value="{{color.value}}" *ngFor="let color of colors">{{color.name}}</mat-option>
                  </mat-select>
                </mat-form-field>

                <div class="">
                  <input type="color" class="selected-color" [(ngModel)]="currentUnit.color" name="color"
                    (change)="updateUnit($event)">
                </div>
              </div>

              <div class="form-row">
                <mat-form-field appearance="outline">
                  <mat-label>
                    {{'units.picture' | translate}}
                  </mat-label>

                  <mat-select [(ngModel)]="currentUnit.icon" name="icon" (selectionChange)="updateUnit($event)">
                    <mat-option [value]="picture.icon" *ngFor="let picture of unitIcons">{{picture.name}}</mat-option>
                  </mat-select>
                </mat-form-field>

                <div class="map-image-upload">
                  <div class="map-image-preview picture-preview">
                    <img [src]="'https://unifield.blob.core.windows.net/unit-picture/'+currentUnit.icon" alt=""
                      class="picture-url">
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>

          <mat-accordion>
            <mat-expansion-panel class="expansion-panel">
              <mat-expansion-panel-header class="header-panel">
                <mat-panel-title>
                  <h3>
                    <mat-icon fontIcon="schedule"></mat-icon>
                    {{ 'units.schedule' | translate }}
                  </h3>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="form-row">
                <div class="schedule-div">
                  <table>
                    <thead>
                      <tr>
                        <th [ngClass]="tableHeaderClass()">
                          {{ 'date.day' | translate }}
                        </th>

                        <th [ngClass]="tableHeaderClass()">
                          {{ 'dashboard.filter.startDate' | translate }}
                        </th>

                        <th [ngClass]="tableHeaderClass()">
                          {{ 'dashboard.filter.endDate' | translate }}
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr *ngFor="let day of days">
                        <td class="day">
                          {{ day.name }}
                        </td>

                        <td class="startTime default-time"></td>

                        <td class="endTime default-time"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>

          <mat-accordion>
            <mat-expansion-panel class="expansion-panel">
              <mat-expansion-panel-header class="header-panel">
                <mat-panel-title>
                  <h3>
                    <mat-icon fontIcon="attach_money"></mat-icon>
                    {{'units.cost'|translate}}
                  </h3>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="form-row">
                <mat-form-field appearance="outline">
                  <mat-label>{{'units.cost_unit' | translate}}</mat-label>
                  <input matInput type="number" [(ngModel)]="currentUnit.costByUnit" placeholder="0"
                    (change)="updateUnit($event)" name="costByUnit">
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>{{'measure.unit' | translate}}</mat-label>
                  <mat-select [(ngModel)]="currentUnit.unitOfMeasure" name="unitOfMeasure"
                    (selectionChange)="updateUnit($event)">
                    <mat-option [value]="measure.value" *ngFor="let measure of measures">{{measure.name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </form>

        <form class="form" *ngIf="sidepanelType == 'tracker'">

          <div class="info-banner warn-banner" *ngIf="isCurrentTrackerConnecting">
            <mat-icon>bluetooth_searching</mat-icon>
            <span>{{'trackers.connecting_blocks_edit'|translate}}</span>
          </div>

          <div [class.connecting-disabled]="isCurrentTrackerConnecting">
          <mat-accordion>
            <mat-expansion-panel class="expansion-panel" [expanded]="true">
              <mat-expansion-panel-header class="header-panel">
                <mat-panel-title>
                  <h3>
                    <mat-icon fontIcon="info"></mat-icon>
                    {{'resources.info_tracker' | translate}}
                  </h3>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="badges-row" *ngIf="currentTracker.id">
                <div class="badge" [matTooltip]="'datatable.id' | translate">
                  <mat-icon>badge</mat-icon>
                  <span class="badge-text">{{ currentTracker.id }}</span>
                  <mat-icon class="copy-btn" (click)="copy(currentTracker.id)">content_copy</mat-icon>
                </div>
                <div class="badge" *ngIf="currentTracker.uuid" [matTooltip]="'trackers.uuid' | translate">
                  <mat-icon>fingerprint</mat-icon>
                  <span class="badge-text">{{ currentTracker.uuid }}</span>
                  <mat-icon class="copy-btn" (click)="copy(currentTracker.uuid)">content_copy</mat-icon>
                </div>
              </div>

              <div class="form-row">
                <mat-form-field appearance="outline" class="header-input">
                  <mat-label>{{'form.name' | translate}}</mat-label>

                  <input matInput placeholder="{{'form.name' | translate}}" [(ngModel)]="currentTracker.name"
                    name="name" (change)="updateTracker($event)">

                  <mat-hint class="error-unique" *ngIf="errorName">{{'trackers.error_unique' | translate}} </mat-hint>
                </mat-form-field>
              </div>

            </mat-expansion-panel>
          </mat-accordion>

          <mat-accordion>
            <mat-expansion-panel class="expansion-panel" [expanded]="true">
              <mat-expansion-panel-header class="header-panel">
                <mat-panel-title>
                  <h3>
                    <mat-icon fontIcon="settings"></mat-icon>
                    {{'resources.tracker_config' | translate}}
                  </h3>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <!-- Every device type: the form below edits the tracker's own settings directly
                   (see saveDeviceDraft()) - the select above it shows the template linked to the
                   tracker (tracker.config) and picking one prefills the fields from it. -->
              <div [class.connecting-disabled]="isCurrentTrackerConnecting">
                <div class="config-select-row">
                  <mat-form-field appearance="outline" class="header-input">
                    <mat-label>{{'resources.select_kyd_template'|translate}}</mat-label>

                    <mat-select [value]="deviceEditor.appliedTemplateId" (selectionChange)="deviceEditor.applyTemplate($event.value)"
                      name="deviceTemplate">
                      <mat-option *ngFor="let config of deviceEditor.templates" [value]="config.id">{{config.name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="template-hint">{{'resources.select_kyd_template_hint'|translate}}</div>

                <app-tracker-config-form [config]="deviceEditor.draft" [lockType]="currentTracker.type" [hideName]="true"
                  [hideCancel]="true" (save)="saveDeviceDraft()"
                  (saveAsTemplate)="saveDeviceDraftAsTemplate()"></app-tracker-config-form>
              </div>

              <div class="form-row" *ngIf="currentTracker.type !== 'KYD'">
                <mat-form-field appearance="outline">
                  <mat-label>{{'trackers.version'|translate}}</mat-label>
                  <input matInput placeholder="{{'trackers.version' | translate}}" [(ngModel)]="currentTracker.version"
                    name="version" (change)="updateTracker($event)">
                </mat-form-field>

              </div>
            </mat-expansion-panel>
          </mat-accordion>

          <mat-accordion>
            <mat-expansion-panel class="expansion-panel" [expanded]="true">
              <mat-expansion-panel-header class="header-panel">
                <mat-panel-title>
                  <h3>
                    <mat-icon fontIcon="handyman"></mat-icon>
                    {{'resources.tracker_maintenance' | translate}}
                  </h3>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="form-row">
                <mat-form-field appearance="outline">
                  <mat-label>{{'resources.tracker_hardware'| translate}}</mat-label>
                  <textarea matInput rows="2" (change)="updateTracker()" [(ngModel)]="currentTracker.comment"
                    name="comment"></textarea>
                </mat-form-field>
              </div>
              <div class="form-row">
                <mat-form-field appearance="outline">
                  <mat-label>{{'resources.tracker_events'| translate}}</mat-label>
                  <textarea matInput rows="5" (change)="updateTracker()" [(ngModel)]="currentTracker.description"
                    name="description"></textarea>
                </mat-form-field>
              </div>

              <mat-divider></mat-divider>

              <div class="linked-interventions">
                <h4 class="linked-interventions-title">{{'resources.tracker_linked_interventions' | translate}}</h4>

                <div class="loading-spinner" *ngIf="loadingLinkedInterventions">
                  <app-spinner></app-spinner>
                </div>

                <ng-container *ngIf="!loadingLinkedInterventions">
                  <ul class="linked-interventions-list" *ngIf="linkedInterventions.length; else noLinkedInterventions">
                    <li *ngFor="let intervention of linkedInterventions">
                      <a class="linked-intervention-item" role="button" tabindex="0"
                        [attr.aria-label]="(intervention.category + ' — ' + intervention.subType)"
                        (click)="openLinkedIntervention(intervention.id)"
                        (keydown.enter)="openLinkedIntervention(intervention.id)"
                        (keydown.space)="openLinkedIntervention(intervention.id); $event.preventDefault()">
                        <span class="linked-intervention-category">{{ intervention.category }} — {{ intervention.subType }}</span>
                        <span class="linked-intervention-date" *ngIf="intervention.dueDate || intervention.createdDate">
                          {{ (intervention.dueDate || intervention.createdDate) | timeFormat }}
                        </span>
                      </a>
                    </li>
                  </ul>

                  <ng-template #noLinkedInterventions>
                    <p class="no-linked-interventions">{{'resources.tracker_no_linked_interventions' | translate}}</p>
                  </ng-template>
                </ng-container>

                <lib-button icon="add" text="{{'resources.tracker_add_intervention' | translate}}"
                  (click)="addInterventionForTracker()"></lib-button>
              </div>
            </mat-expansion-panel>
          </mat-accordion>

          <mat-accordion>
            <mat-expansion-panel class="expansion-panel">
              <mat-expansion-panel-header class="header-panel">
                <mat-panel-title>
                  <h3>
                    <mat-icon fontIcon="analytics"></mat-icon>
                    {{'resources.tracker_activity' | translate}}
                  </h3>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="form-row">
                <mat-form-field appearance="outline">
                  <mat-label>{{'trackers.stats.title'| translate}}</mat-label>
                  <div class="loading-spinner" *ngIf="currentTracker.loadingStats">
                    <app-spinner></app-spinner>
                  </div>

                  <textarea matInput [(ngModel)]="currentTracker.stats" rows="10" name="stats" readonly></textarea>
                </mat-form-field>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
          </div>

        </form>
      </div>
    </div>
  </div>
</ng-container>

<!-- Chip indicator -->
<ng-template #chipIndicator let-trackers>
  <div class="chip-div">
    <div class="chip-list" *ngFor="let tracker of trackers">
      <mat-chip-set>
        <mat-chip>
          @if (isMobile) {
          <span>{{tracker.name.length > 8 ? (tracker.name | slice:0:8) + '...' : tracker.name}}</span>
          }
          @else {
          <span>{{tracker.name}}</span>
          }
        </mat-chip>
      </mat-chip-set>

      <lib-chip *ngIf="tracker.batteryLevel > 20" color="primary" icon="battery_full" text="{{tracker.batteryLevel}}%">
      </lib-chip>

      <lib-chip *ngIf="tracker.batteryLevel <= 20 && tracker.batteryLevel >= 0" color="danger" icon="battery_alert"
        text="{{tracker.batteryLevel}}%">
      </lib-chip>

      <lib-chip *ngIf="tracker.batteryLevel== -1" icon="battery_unknown" text="{{'status.active'|translate}}">
      </lib-chip>

      <lib-chip *ngIf="tracker.shackleBattery > 20" color="primary" class="shackle-icon" svgIcon="shackle_full">
      </lib-chip>

      <lib-chip *ngIf="tracker.shackleBattery <= 20 && tracker.shackleBattery >= 0" color="danger" class="shackle-icon"
        svgIcon="shackle" text="{{tracker.shackleBattery}}%">
      </lib-chip>
    </div>
  </div>
</ng-template>

<!-- Helper pop -->
<ng-template #helperPop>
  <div>
    <h3 style="margin-bottom: 8px;">Dispositif</h3>
    <p>Cette colonne liste les dispositifs de l'unité avec leur nom et les niveaux de batterie du
      tracker et du peson, signalés par un code couleur pour une lecture rapide.</p>

    <div class="color">
      <div class="multiUnit">
        <span class="spanUnit">Batterie dispositif</span>
        <div class="rowUnit">
          <lib-chip color="primary" icon="battery_full"></lib-chip>
          <span class="full">> 20%</span>
        </div>

        <div class="rowUnit">
          <lib-chip color="danger" icon="battery_alert"></lib-chip>
          <span class="danger">&lt;= 20%</span>
        </div>

        <div class="rowUnit">
          <lib-chip icon="battery_unknown"></lib-chip>
          <span>Format inconnu</span>
        </div>
      </div>

      <div class="multiUnit">
        <span>Batterie du peson</span>
        <div class="rowUnit">
          <lib-chip color="primary" class="shackle-icon" svgIcon="shackle_full"></lib-chip>
          <span class="full">> 20%</span>
        </div>

        <div class="rowUnit">
          <lib-chip color="danger" class="shackle-icon" svgIcon="shackle"></lib-chip>
          <span class="danger">&lt;= 20%</span>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- CARDS UNIT -->
<ng-template #cardUnits>
  <div class="card-container">

    <mat-card *ngIf="unitsData.data.length === 0">
      <mat-card-content class="no-data">
        <mat-icon fontIcon="cancel"></mat-icon>
        {{'events.empty_data' | translate}}
      </mat-card-content>
    </mat-card>

    <mat-card *ngFor="let row of unitsData.data">
      <mat-card-content class="card-content">
        <div class="status-infos">
          <div class="status-led {{row.colorName}}"></div>

          <div class="card">
            <div class="th">
              <mat-icon fontIcon="devices"></mat-icon>
              {{ row.name }}
            </div>

            <div class="th">
              <mat-icon fontIcon="category"></mat-icon>
              {{ row.type }}
            </div>

            <div class="th">
              <mat-icon fontIcon="memory"></mat-icon>
              <ng-container *ngTemplateOutlet="chipIndicator; context: { $implicit: row.trackers}"></ng-container>
            </div>
          </div>
        </div>

        <div class="card-actions">
          <lib-button (click)="editItem(row, 'unit')" class="btn" color="none" textColor="secondary" icon="edit">
          </lib-button>

          <lib-button color="none" (click)="delete(row, 'unit')" icon="delete" textColor="danger">
          </lib-button>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</ng-template>

<!-- Cards trackers -->
<ng-template #cardTrackers>
  <div class="card-container">

    <mat-card *ngIf="trackersData.data.length === 0">
      <mat-card-content class="no-data">
        <mat-icon fontIcon="cancel"></mat-icon>
      </mat-card-content>
    </mat-card>

    <mat-card *ngFor="let row of trackersData.data">
      <mat-card-content class="card-content">
        <div class="status-infos">
          <mat-checkbox *ngIf="multiSelectMode" [(ngModel)]="row.selected"></mat-checkbox>
          <div class="status-led {{row.colorName}}"></div>

          <div class="card">
            <div class="th">
              <mat-icon fontIcon="track_changes"></mat-icon>
              {{row.name}}
            </div>

            <div class="th">
              <mat-icon fontIcon="vpn_key"></mat-icon>
              {{row.version}}
            </div>

            <div class="th">
              <mat-icon fontIcon="history"></mat-icon>
              {{row.lastUpdate.toString() | timeFormat : 'dd/MM/yyyy HH:mm:ss'}}
            </div>
          </div>
        </div>

        <div class="card-actions">
          <lib-button (click)="editItem(row, 'tracker')" class="btn" color="none" textColor="secondary" icon="edit">
          </lib-button>

          <lib-button color="none" (click)="delete(row, 'tracker')" icon="delete" textColor="danger">
          </lib-button>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</ng-template>